import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";

import { AuthenticationService } from "app/services/authentication.service";

@Injectable()
export class RedirectionGuard implements CanActivate {

    constructor(
        private _authenticationService: AuthenticationService,
        private _router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      let user = this._authenticationService.authenticatedUser;

      if (!user) {
        this._router.navigateByUrl("/account/signin");
      } else {
        this._router.navigateByUrl("/call/create");
      } 

      return false;
    }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/redirection-guard.service.ts